import { displayNotImplemented } from "../../../../../shared/services/Notifications/NotificationServices";

interface ErrorWrapProps {
  children: React.ReactNode;
}

export default function ErrorWrap({ children }: ErrorWrapProps) {
  return (
    <div onClick={displayNotImplemented} style={{ display: "inline-block" }}>
      <div style={{ pointerEvents: "none" }}>{children}</div>
    </div>
  );
}
